import React from "react";
import { Container } from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { formatTime } from "../../../components/CONSTANTS";
import moment from "moment";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";


export const AdminLogGrid = ({ logs, error, errorText, loading }) => {
    const [readOnly, setReadOnly] = React.useState(false);


    const { SearchBar } = Search;


    const dateFormatter = (cell) => {

        if (cell) {
            return moment(cell.toDate()).format("YYYY-MM-DD")
        } else return <span>Inget datum</span>
    }


    const editUser = (cell) => {
        return (
            <React.Fragment>
                {cell}
                <Link to={`/leadtub-admin-user-details/${cell}`}>
                    <Button onClick={() => setReadOnly(!readOnly)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            className="bi bi-pencil" viewBox="0 0 16 16">
                            <path
                                d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                        </svg>
                    </Button>

                </Link>
            </React.Fragment>
        )
    }

    const editCompany = (cell) => {
        return (
            <React.Fragment>
                {cell}
                <Link to={`/leadtub-admin-company/${cell}`}>
                    <Button onClick={() => setReadOnly(!readOnly)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            className="bi bi-pencil" viewBox="0 0 16 16">
                            <path
                                d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                        </svg>
                    </Button>

                </Link>
            </React.Fragment>
        )
    }

    const columns = [
        {
            dataField: 'company',
            text: 'Företag',
            sort: true,
            formatter: editCompany,
            headerStyle: { textDecoration: 'underline', cursor: 'pointer' }
        },
        {
            dataField: 'addedBy',
            text: 'Tillagd utav (klicka för att se användarinfo)',
            sort: true,
            formatter: editUser,
            headerStyle: { textDecoration: 'underline', cursor: 'pointer' }
        },
        {
            dataField: 'addedAy',
            text: 'Tillagt vid tidpunkt',
            sort: true,
            formatter: dateFormatter,
            headerStyle: { textDecoration: 'underline', cursor: 'pointer' }
        },


    ];


    return (
        <Container fluid className={"leadsGrid"}>
            <Container>
                <h1>
                    Tillagda företag
                </h1>

            </Container>


            <ToolkitProvider
                keyField="id"
                data={logs}
                columns={columns}
                search
                condensed={true}
            >
                {props => (
                    <div>
                        <SearchBar placeholder="Sök" srText={null}
                            className="SearchBar" {...props.searchProps} />
                        <BootstrapTable wrapperClasses="table-responsive" {...props.baseProps} />
                    </div>
                )}
            </ToolkitProvider>
        </Container>
    )
}
